import React from 'react'
import classNames from 'classnames'
import { IconArrowRight } from '@tabler/icons-react'

// The Now → Projected (or Baseline → Measured) conversion-rate panel that sits
// on the right of an insight/experiment card, and as a boxed block in the
// drawer. Each column carries a monthly count beneath its percentage; `measured`
// colors the second column green (a realized result) instead of the projection
// purple. `boxed` renders the left-aligned bordered drawer variant.
export const ConversionPanel = ({
  heading = 'Conversion rate',
  nowKey,
  nowValue,
  nowSub,
  projKey,
  projValue,
  projSub,
  measured = false,
  boxed = false,
}) => (
  <div className={classNames('conversion-panel', { 'conversion-panel--boxed': boxed })}>
    <div className="conversion-panel__heading">{heading}</div>
    <div className="conversion-panel__cols">
      <div className="conversion-panel__col">
        <div className="conversion-panel__key">{nowKey}</div>
        <div className="conversion-panel__value">{nowValue}</div>
        {nowSub && (
          <div className="conversion-panel__col-sub conversion-panel__col-sub--now">{nowSub}</div>
        )}
      </div>
      <IconArrowRight className="conversion-panel__arrow icon-svg" />
      <div
        className={classNames('conversion-panel__col', {
          'conversion-panel__col--projected': !measured,
          'conversion-panel__col--measured': measured,
        })}
      >
        <div className="conversion-panel__key">{projKey}</div>
        <div className="conversion-panel__value">{projValue}</div>
        {projSub && (
          <div
            className={classNames('conversion-panel__col-sub', {
              'conversion-panel__col-sub--projected': !measured,
              'conversion-panel__col-sub--measured': measured,
            })}
          >
            {projSub}
          </div>
        )}
      </div>
    </div>
  </div>
)
